"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryStringProvider = void 0;
const qs = __importStar(require("query-string"));
const coerce_1 = require("./coerce");
class QueryStringProvider {
    constructor(app, queryString) {
        this.app = app;
        this.queryString = queryString;
    }
    apply(_props) {
        const overrides = [];
        const obj = qs.parse(this.queryString);
        for (const query in obj) {
            const [app, ...rest] = query.split('/');
            if (app !== this.app || rest.length === 0) {
                continue;
            }
            const key = rest.join('/');
            overrides.push({ key, value: (0, coerce_1.coerce)(obj[query]), source: 'query-string' });
        }
        return overrides;
    }
}
exports.QueryStringProvider = QueryStringProvider;
//# sourceMappingURL=query-string-provider.js.map